import PropTypes from "prop-types";

import ProductMention from "../ProductMention";
import ProductReviewRating from "./ProductReviewRating";
import PriceContainer from "../PriceContainer";

function ProductBrief({
  prices,
  pricesLoading,
  product,
  discountsInfo,
  isPurchaseRestricted,
  scrollToReviews,
  componentType,
}) {
  const { title, seoContent, shopifyId, tags, isPreOrder, preOrderShippingDate, productType } =
    product;

  const productMentionData = {
    id: shopifyId,
    tags,
    isPreOrder,
    preOrderShippingDate,
    type: productType,
  };

  const productName = title?.split(" - ")[1] || title;
  const productSubname = title?.split(" - ")[0];

  return (
    <div>
      <ProductMention
        prices={prices}
        product={productMentionData}
        globalProductMention={discountsInfo[0]?.globalProductText}
        componentType={componentType}
      />
      <div className="pdp_details_container pdp_details_container_pdp">
        <div className="pdp_details_container_title">
          {seoContent && seoContent?.metaTitle ? (
            <>
              <h1 style={{ display: "none" }}>{seoContent?.metaTitle}</h1>
              <div className="pdp_details_container_title_heading">
                <span className="pdp_details_container_subname">{productSubname}</span>
                <span style={{ display: "none" }}>&nbsp;</span>
                <span className="pdp_details_container_name">{productName}</span>
              </div>
            </>
          ) : (
            <h1 className="pdp_details_container_title_heading">
              <span className="pdp_details_container_subname">{productSubname}</span>
              <span style={{ display: "none" }}>&nbsp;</span>
              <span className="pdp_details_container_name">{productName}</span>
            </h1>
          )}

          <ProductReviewRating
            componentType={componentType}
            onClick={scrollToReviews}
            productId={shopifyId}
          />
        </div>

        {!isPurchaseRestricted && (
          <PriceContainer
            productId={shopifyId}
            prices={prices}
            pricesLoading={pricesLoading}
            componentType={componentType}
            tags={tags}
          />
        )}
      </div>
    </div>
  );
}

ProductBrief.propTypes = {
  prices: PropTypes.object,
  pricesLoading: PropTypes.bool,
  product: PropTypes.shape({
    title: PropTypes.string,
    seoContent: PropTypes.shape({
      metaTitle: PropTypes.string,
    }),
    shopifyId: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    isPreOrder: PropTypes.bool,
    preOrderShippingDate: PropTypes.string,
    productType: PropTypes.string,
  }),
  discountsInfo: PropTypes.arrayOf(
    PropTypes.shape({
      globalProductText: PropTypes.string,
    })
  ),
  isPurchaseRestricted: PropTypes.bool,
  scrollToReviews: PropTypes.func,
  componentType: PropTypes.string,
};

export default ProductBrief;
